const tsResourcesUrl = '/ts-resources';

export default tsResourcesUrl;
